import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

const Creatives = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  RoleBasedRedirector: lazy(() => import('./components/RoleBasedRedirector.tsx')),
  Digital: {
    CreativesList: lazyNamed(() => import('./containers/Digital/containers/CreativesList/index.tsx'), 'CreativesList'),
    CreativeHistory: lazyNamed(() => import('./containers/Digital/containers/CreativeHistory/index.tsx'), 'CreativeHistory'),
    CreativeForm: lazyNamed(() => import('./containers/Digital/containers/CreativeForm/index.tsx'), 'CreativeForm'),
    BulkUploadNative: lazyNamed(() => import('./containers/Digital/containers/BulkUploadNative/index.tsx'), 'BulkUploadNative'),
    Providers: lazyNamed(() => import('./containers/Digital/components/Providers.tsx'), 'Providers'),
  },
  Print: {
    CreativesList: lazyNamed(() => import('./containers/Print/containers/CreativesList/index.tsx'), 'CreativesList'),
    CreativeForm: lazy(() => import('./containers/Print/containers/CreativeFormPage/index.tsx')),
  },
  AdServer: {
    CreativesList: lazyNamed(() => import('./containers/AdServer/containers/CreativesList/index.tsx'), 'CreativesList'),
    CreativeDetails: lazy(() => import('./containers/AdServer/containers/CreativeDetails/index.tsx')),
  },
  Content: {
    Editor: lazyNamed(() => import('./containers/Content/Editor/index.tsx'), 'ContentEditor'),
  },
  AdQualityReports: {
    LatestReport: lazyNamed(() => import('./containers/AdQualityReports/containers/LatestReport.tsx'), 'LatestReport'),
    ReportList: lazyNamed(() => import('./containers/AdQualityReports/containers/ReportList/index.tsx'), 'ReportList'),
    ReportDetails: lazyNamed(() => import('./containers/AdQualityReports/containers/ReportDetails/index.tsx'), 'ReportDetails'),
    Dashboard: lazyNamed(() => import('./containers/AdQualityReports/containers/Dashboard/index.tsx'), 'Dashboard'),
  },
  Templates: {
    TemplatesList: lazyNamed(() => import('./containers/Templates/index.ts'), 'TemplatesList'),
    TemplateForm: lazyNamed(() => import('./containers/Templates/index.ts'), 'TemplateForm'),
  },
};

export default Creatives;
